module.exports = __webpack_public_path__ + "img/header.0c3c9d1b.png";